// extracted by mini-css-extract-plugin
export default {"homeBgLight":"red","homeBgDark":"#0a0f3a","colorProjectBg":"#f3f4f5","colorHomeMain":"red","color-home-secondary":"#0a0f3a"};